import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../common/component/Wrapper';
import FontIcon, { SolidIcons } from './../../../../common/component/FontIcon';
import { omit } from 'lodash';
import { Statistic, Card, Row, Col, Icon, Skeleton } from 'antd';
import './ReportSummary.less';
import { ORDER } from '../../../../../../constants/Define';

let permisionActions = [];
const defaultState = {

};

export default class ReportSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
    }

    componentDidMount() {

    }

    render() {
        const { t, report, loading } = this.props;
        return (!loading ?
            <Wrapper className="sale-report-summary">
                <Row>
                    <Col span={12}>
                        <Card>
                            <Statistic
                                title={t(`item.report.totalRevenue`)}
                                value={report.totalRevenue}
                                valueStyle={{ color: '#3f8600' }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons.faMoneyBill} />} />}
                                suffix={t(`currencySymbol`)}
                            />
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card>
                            <Statistic
                                title={t(`item.report.totalOrder`)}
                                value={report.totalOrder}
                                valueStyle={{ color: '#cf1322' }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons.faShoppingCart} />} />}
                            />
                        </Card>
                    </Col>

                </Row>
                <Row>
                    <Col span={6}>
                        <Card>
                            <Statistic
                                title={t(`item.report.voucherOrders`)}
                                value={report.voucherOrders}
                                valueStyle={{ color: ORDER.TYPES.VOUCHER.color }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons[ORDER.TYPES.VOUCHER.icon]} />} />}
                            />
                        </Card>
                    </Col>
                    {!!report.tourOrders &&
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title={t(`item.report.tourOrders`)}
                                    value={report.tourOrders}
                                    valueStyle={{ color: ORDER.TYPES.TOUR.color }}
                                    prefix={<Icon component={() => <FontIcon icon={SolidIcons[ORDER.TYPES.TOUR.icon]} />} />}
                                />
                            </Card>
                        </Col>
                    }
                    <Col span={6}>
                        <Card>
                            <Statistic
                                title={t(`item.report.flightOrders`)}
                                value={report.flightOrders}
                                valueStyle={{ color: ORDER.TYPES.FLIGHT.color }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons[ORDER.TYPES.FLIGHT.icon]} />} />}
                            />
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card>
                            <Statistic
                                title={t(`item.report.hotelOrders`)}
                                value={report.hotelOrders}
                                valueStyle={{ color: ORDER.TYPES.HOTEL.color }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons[ORDER.TYPES.HOTEL.icon]} />} />}
                            />
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card>
                            <Statistic
                                title={t(`item.report.vinWonderOrders`)}
                                value={report.vinWonderOrders}
                                valueStyle={{ color: ORDER.TYPES.VINWONDER.color }}
                                prefix={<Icon component={() => <FontIcon icon={SolidIcons[ORDER.TYPES.VINWONDER.icon]} />} />}
                            />
                        </Card>
                    </Col>
                </Row>
            </Wrapper>
            : this.renderLoading()
        );
    }

    renderLoading() {
        return (
            <Wrapper className="ibox">
                <Card><Skeleton active paragraph={{ row: 7 }} /></Card>
            </Wrapper>
        )
    }
}

ReportSummary.defaultProps = {
    report: {},
    loading: false,
}
